import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      position="top-right"
      richColors
      expand
      duration={10000}
      // Push the toast portal above every Radix Dialog / modal (Radix uses z-50).
      style={{ zIndex: 2147483647 }}
      toastOptions={{
        duration: 10000,
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg group-[.toaster]:max-w-[560px]",
          description:
            "group-[.toast]:text-muted-foreground group-[.toast]:whitespace-pre-wrap group-[.toast]:break-words",
          title: "group-[.toast]:whitespace-pre-wrap group-[.toast]:break-words",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
